<script>
    import { onMount, getContext } from 'svelte';
    import { axisTop } from 'd3-axis';
    import { select } from 'd3-selection';
    import { scaleLinear, scaleSequential } from 'd3-scale';
    import { interpolateBlues, interpolateOranges } from 'd3-scale-chromatic';

    // --- Properties
    export let dataKey;
    const {
        matches,
        activeMatch: active,
        hoverMatch,
        unhoverMatch,
        rejectMatch,
    } = getContext(dataKey);
    const width = 100;

    // --- Scales
    const widthScale = scaleLinear([0, width / 2]);
    const priceColor = scaleSequential(interpolateOranges);
    const transactionColor = scaleSequential(interpolateBlues);

    // --- Axes
    let priceAxis;
    let transactionAxis;

    onMount(() => {
        const tickLabels = ['0', '0.5', '1'];
        select(priceAxis)
            .attr('transform', 'translate(0, 20)')
            .call(
                axisTop(scaleLinear([width / 2, 0]))
                    .ticks(3)
                    .tickFormat((d, i) => tickLabels[i])
            )
            .call((g) => g.select('.domain').remove());
        select(transactionAxis)
            .attr('transform', 'translate(0,20)')
            .call(
                axisTop(scaleLinear([width / 2, width]))
                    .ticks(2)
                    .tickValues([0.5, 1])
                    .tickFormat((d, i) => tickLabels[i + 1])
            )
            .call((g) => g.select('.domain').remove());
    });

    // --- Sorting
    let sortDesc = false;
    let sortCol = 'default';

    function sortMatches() {
        if (sortCol !== 'matches') {
            sortDesc = true;
            sortCol = 'matches';
        }
        if (sortDesc) {
            $matches = $matches.sort((a, b) => b.num_matches - a.num_matches);
            sortDesc = false;
        } else {
            $matches = $matches.sort((a, b) => a.num_matches - b.num_matches);
            sortDesc = true;
        }
    }

    function sortPrices() {
        if (sortCol !== 'corr') {
            sortDesc = true;
            sortCol = 'corr';
        }
        if (sortDesc) {
            $matches = $matches.sort((a, b) => b.correlation - a.correlation);
            sortDesc = false;
        } else {
            $matches = $matches.sort((a, b) => a.correlation - b.correlation);
            sortDesc = true;
        }
    }

    function sortTransactions() {
        if (sortCol !== 'transactions') {
            sortDesc = true;
            sortCol = 'transactions';
        }
        if (sortDesc) {
            $matches = $matches.sort(
                (a, b) => b.percentage_matches - a.percentage_matches
            );
            sortDesc = false;
        } else {
            $matches = $matches.sort(
                (a, b) => a.percentage_matches - b.percentage_matches
            );
            sortDesc = true;
        }
    }
</script>

<div id="matches" style="flex-basis:{width}px;max-width:{width}px">
    <div class="header">
        <span style="width:{width}px" on:click={sortMatches}>Matches</span>
    </div>
    <div class="buttons">
        <span on:click={sortPrices}>ρ</span>
        <span on:click={sortTransactions}>#</span>
    </div>
    <svg class="axes" height="20px">
        <g class="price" bind:this={priceAxis} />
        <g class="transaction" bind:this={transactionAxis} />
    </svg>
    {#each $matches as m, i}
        <div
            class="match"
            class:fade={!$active[i]}
            on:mouseenter={() => hoverMatch(m)}
            on:mouseleave={() => unhoverMatch(m)}
            on:click={() => rejectMatch(m)}
        >
            <div
                class="padding"
                style="width:{widthScale(1 - m.correlation)}px;"
            />
            <div
                class="price"
                style="width:{widthScale(
                    m.correlation
                )}px;background-color:{priceColor(m.correlation)}"
            />
            <div
                class="transaction"
                style="width:{widthScale(
                    m.percentage_matches
                )}px;background-color:{transactionColor(m.percentage_matches)}"
            />
            <!-- <div class='padding' style='width:{widthScale(1-m.percentage_matches)}px;'></div> -->
        </div>
    {/each}
</div>

<style>
    #matches {
        display: flex;
        flex-grow: 0;
        flex-shrink: 0;
        flex-direction: column;
    }

    #matches div {
        display: flex;
        flex-direction: row;
        flex-shrink: 0;
        flex-grow: 0;
    }

    .header {
        height: 20px;
        margin-bottom: 10px;
    }

    .header span {
        line-height: 20px;
        display: block;
        text-align: center;
        cursor: pointer;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .buttons {
        height: 15px;
        font-size: 15px;
        margin-bottom: 9px !important;
    }

    .buttons span {
        width: 50%;
        display: block;
        text-align: center;
        cursor: pointer;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        line-height: 15px;
    }

    #matches svg {
        overflow: visible;
        margin-bottom: 6px;
    }

    .match {
        background-color: #ddd;
        height: 10px;
        margin-top: 0px;
        margin-bottom: 10px;
        cursor: pointer;
    }

    .match.fade {
        opacity: 0.5;
    }

    .match div {
        position: relative;
        height: 100%;
    }
</style>
